import { Routes } from '@angular/router';
import {HomeComponent} from "./pages/home/home.component";
import {APP_ROUTE_NAME} from "./constants/app-route-names.constant";
import {ServicesComponent} from "./pages/services/services.component";
import {ContactUsComponent} from "./pages/contact-us/contact-us.component";
import {AboutUsComponent} from "./pages/about-us/about-us.component";

export const routes: Routes = [
  {
    path: APP_ROUTE_NAME.EMPTY,
    redirectTo: APP_ROUTE_NAME.HOME,
    pathMatch: "full"
  },
  {
    path: APP_ROUTE_NAME.HOME,
    component:HomeComponent,
    title: 'Umbrella Travel'
  },
  {
    path: APP_ROUTE_NAME.SERVICES,
    component:ServicesComponent,
    title: 'Umbrella Travel - Services'
  },
  {
    path: APP_ROUTE_NAME.CONTACT_US,
    component:ContactUsComponent,
    title: 'Umbrella Travel - Contact us'
  },
  {
    path: APP_ROUTE_NAME.ABOUT_US,
    component:AboutUsComponent,
    title: 'Umbrella Travel - About us'
  }
];
